const OverlayWrapper = ({children, onClick=null, className=''}) => (
    // <div className="overlay" onClick={onClick}>
    <div className="overlay">
        <div className={"content" + className}>
            {children}
        </div>
    </div>
)

export default OverlayWrapper